export default __webpack_public_path__ + "static/logo-a761172214e61b37c90d1c6a8878f7d7.png";